var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"tabdrop non-selectable",class:_vm.bindClass},[_c('a',{staticClass:"tab-trigger",attrs:{"data-target":"comments"},on:{"click":_vm.click}},[_c('u-icon',{attrs:{"name":_vm.icon,"type":"fa","icon-style":"light"}}),_c('span',[_vm._v(_vm._s(_vm.label))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }